import {useState, useEffect} from 'react'
import React from 'react'
import { Box, Typography } from '@mui/material'
import supabase from '../../../supabaseClient'

function SummaryCard({ label, value, highlight }) {

  return (
    <Box sx={{
      flex: 1,
      minWidth: 160,
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      px: 2.5,
      py: 2,
    }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
        {label}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, color: highlight ? 'error.main' : 'text.primary' }}>
        {value}
      </Typography>
    </Box>
  );
}

function Last12MonthsReport({idConfig}) {

    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const totalHours = report.reduce((acc, r) => {
        const ci = new Date(r.check_in);
        const co = new Date(r.check_out);
        return acc + (co - ci) / 1000 / 60 / 60;
    }, 0);

    const totalSalary = report.reduce((acc, r) => {
        const ci = new Date(r.check_in);
        const co = new Date(r.check_out);
        const hours = (co - ci) / 1000 / 60 / 60;
        return acc + hours * (r.employees.hourly_rate || 0);
    }, 0);

    const hoursByEmployee = {};
        report.forEach(r => {
        const id = r.employees.id;
        const hours = (new Date(r.check_out) - new Date(r.check_in)) / 1000 / 60 / 60;
        hoursByEmployee[id] = (hoursByEmployee[id] || 0) + hours;
        });
    

    const dateFrom = new Date()
        dateFrom.setMonth(dateFrom.getMonth() - 12)

    const fetchReport = async () => {
        if (!idConfig) return;
        setLoading(true);
        const  {data, error} = await supabase
            .from('attendance')
            .select('check_in, check_out, employee_id, employees(id, name, surname, hourly_rate)')
            .eq('id_configuration', idConfig)
            .gte('check_in', `${dateFrom.toISOString().split('T')[0]}T00:00:00`)
            .lte('check_in', `${new Date().toISOString().split('T')[0]}T23:59:59`)
            .not('check_in', 'is', null)
            .not('check_out', 'is', null);
        if (!error) {
            console.log('Fetched report data:', data);
        setReport(data || []);
        }
        setLoading(false);
    }

    useEffect(() => { fetchReport() }, [idConfig]);

    return(
        <>
            <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    Statystyki z ostatnich 12 miesięcy
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', width: '50%', mx: 'auto'}}>
                <SummaryCard label="Łączne godziny z ostatnich 12 miesięcy" value={totalHours.toFixed(2)} />
                <SummaryCard label="Wypłaty z ostatnich 12 miesięcy" value={totalSalary.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
            </Box>
        </>
    )
}


export default Last12MonthsReport;